import { render } from "./villageTripBookAnswer.vue?vue&type=template&id=f2129726&ts=true"
import script from "./villageTripBookAnswer.vue?vue&type=script&lang=ts"
export * from "./villageTripBookAnswer.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__